import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnDestroy, OnInit, ViewChild, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { IonContent, IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { C_Result } from "@sports-models/index";
import { Observable, Subject, Subscription, catchError, of, switchMap, takeUntil } from "rxjs";

// models
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { C_Event } from "@sports-models/index";

// others
import { SportsBasePage, TrackingInfo } from "@sports-pages/index";
import { SportHandleList } from "@sports-utils/index";

// pipes
import { DictionaryPipe } from "@sports-pipes/sports.dictionary.pipe";
import { SportsExtractDatePipe } from "@sports-pipes/sports.extract-date.pipe";

// services
import { SportBookService, SportService, TicketService } from "@sports-services/index";

import { EventsService } from "@providers/EventsService";
import { NewBaseService } from "@providers/newBase.service";
import { DeviceService } from "@services/device.service";
import { SportNavigationService } from "@sports-services/index";

// components
import { CodereFooterComponent } from "@components/mso/footer/codere-footer/codere-footer";
import {
  SbButtonComponent,
  SbCounterComponent,
  SbDropdownComponent,
  SbGridContentExpandedComponent,
  SbGridContentTeamsComponent,
  SbGridItemComponent,
  SbOverviewScoreRegularComponent,
  SbOverviewScoreSetsComponent,
  SbSimpleNavbarComponent,
} from "@sports-components/index";

// others
import { SPORTS_PATHS } from "@shared-constants/routes";
import { groupBy, orderBy } from "@sports-utils/utils.functions";

// directives
import { SportsBetDisplayDirective } from "@sports-directives/bet-display/bet-display";

// store
import { NewTicketFacade } from "@sports-features/ticket/stores";
import { TicketItemTypesEnum } from "@sports-pages/ticket/utils/ticket.constants";
import { SCOREBOARD_TYPE } from "@sports-utils/sports.constants";

@Component({
  templateUrl: "./sport-events.page.html",
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrls: ["./sport-events.page.scss"],
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    SbSimpleNavbarComponent,
    TranslateModule,
    SbDropdownComponent,
    DictionaryPipe,
    SbGridItemComponent,
    SbOverviewScoreSetsComponent,
    SbOverviewScoreRegularComponent,
    SbButtonComponent,
    CodereFooterComponent,
    SbGridContentTeamsComponent,
    SbGridContentExpandedComponent,
    SportsExtractDatePipe,
    SportsBetDisplayDirective,
    SbCounterComponent,
  ],
})
export class SportEventsPage extends SportsBasePage implements OnInit, OnDestroy {
  @ViewChild(IonContent) content: IonContent;
  eventos: C_Event[];
  selectedSportHandle: string;
  selectedName: string;
  events$: Observable<any>;
  bet$: Subscription;
  canGoBack: boolean = true;
  isDesktop: boolean;

  globalVars: GlobalVarsModel;
  sportService = inject(SportService);
  ticketService = inject(TicketService);
  newTicketFacade = inject(NewTicketFacade);

  extractDate = inject(SportsExtractDatePipe);
  router = inject(Router);
  sportBookService = inject(SportBookService);
  deviceService = inject(DeviceService);
  newBaseService = inject(NewBaseService);
  mySubscription: Subscription;
  isMobile: boolean;
  public events = inject(EventsService);
  sportNavigationService = inject(SportNavigationService);

  sportsNavigationId = undefined;
  stateToSave = {
    scrollPosition: undefined,
  };
  stateToRestore = undefined;

  private unsubscribe$ = new Subject<boolean>();

  SCOREBOARD_TYPE = SCOREBOARD_TYPE;

  constructor() {
    super();
    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();

    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();

    const currentUrl = this.sportNavigationService.navigationState$.getValue().currentUrl;
    this.sportsNavigationId = currentUrl.state.sportsNavigationId;
    this.selectedSportHandle = currentUrl.state.params.SportHandle;
    this.selectedName = SportHandleList[`${currentUrl.state.params.SportHandle}Literal`];
    this.bindEventos();
    this.canGoBack = currentUrl.state.hasBackButton;
  }

  ngOnInit() {
    this.events.publish("footer:refresh");
  }

  getTrackingInfo(): TrackingInfo {
    return {
      uri: encodeURI(`/${this.selectedSportHandle}`),
      description: `Sport events page - ${this.selectedSportHandle}`,
      additionalData: {
        sportHandle: this.selectedSportHandle,
      },
    };
  }

  navigate(_event, market, gameType?: any) {
    if (gameType) {
      return;
    }
    const component = market.isLive ? SPORTS_PATHS.NowLiveDetailPage : SPORTS_PATHS.MercadosPage;
    const eventType = market.isLive ? "AccessToNowLiveDetailPage" : "AccessToMercadosPage";

    if (market.ChildrenCount > 1) {
      this.router.navigate([component], {
        state: { params: market },
        queryParams: { animate: !this.isDesktop },
      });
      this.trackingService.trackEvent([eventType, market.Name, this.globalVars.currentPage.name, "", "event"]);
    } else {
      //nothing. It dont nav to MercadosPage
    }
  }

  public bet(game: any, event: any, gameName: string, type: string) {
    const data = {
      ...game,
      EventDate: this.extractDate.transform(event.StartDate),
      EventName: game.Name,
      GameName: gameName,
    };
    console.log({ game, event, gameName, type });

    this.newTicketFacade.checkSelection(data, data.NodeId, TicketItemTypesEnum.LINE_ITEM);
  }

  bindEventos() {
    const highligthEventAux: C_Event[] = [];
    const params: any = {
      sportHandle: this.selectedSportHandle,
      count: 20,
      gameTypes: null,
    };
    this.sportService
      .getHighligthEventsBySportHandle(params)
      .pipe(
        takeUntil(this.unsubscribe$),
        catchError((err) => {
          console.error("Error fetching highlight events:", err);
          return of([]); // Devuelve un array vacío en caso de error
        }),
      )
      .subscribe((data) => {
        let EventAux: C_Event;

        for (let j = 0; j < data.length; j++) {
          if (EventAux) {
            if (EventAux.Games[0] === data[j].Games[0]) {
              highligthEventAux.push(EventAux);
            } else {
              let resultNew: C_Result;
              let resultOld: C_Result;
              for (let indiceResult = 0; indiceResult < data[j].Games[0].Results.length; indiceResult++) {
                resultNew = data[j].Games[0].Results[indiceResult];
                if (resultOld) {
                  if (resultNew.Odd > resultOld.Odd) {
                    resultNew.upOdd = true;
                  }
                  if (resultNew.Odd < resultOld.Odd) {
                    resultNew.downOdd = true;
                  }
                }
              }
              highligthEventAux.push(data[j]);
            }
          } else {
            highligthEventAux.push(data[j]);
          }
        }

        // Actualiza los eventos y agrúpalos
        this.eventos = orderBy(highligthEventAux, "StartDate");
        this.eventos = groupBy(this.eventos, "LeagueName");

        // Refresh footer
        this.events.publish("footer:refresh");
      });
  }

  onScroll(event) {
    this.stateToSave.scrollPosition = event.detail.scrollTop;
  }

  ngOnDestroy(): void {
    if (this.bet$) {
      this.bet$.unsubscribe();
    }
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
    this.sportNavigationService.injectLastStateToHistory(this.sportsNavigationId, this.stateToSave);
  }
}
